"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Grid = _interopRequireDefault(require("@mui/material/Unstable_Grid2/Grid2"));
var _material = require("@mui/material");
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _Heading = _interopRequireDefault(require("../../elements/Heading/Heading"));
var _system = require("@mui/system");
var _excluded = ["content", "children"],
  _excluded2 = ["stackHeader", "stackImage", "stackAlt", "children"],
  _excluded3 = ["content", "children"],
  _excluded4 = ["userExamples", "userStats"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var JourneyBoxStyles = (0, _styledComponents.default)(_material.Box)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  padding-bottom: 16.25px; \n  padding-top: 16.25px;\n  background-image: url(", ");\n  background-color: ", ";\n  \n  @media (min-width: ", ") {\n    padding-bottom: 32.5px; \n    padding-top: 32.5px;\n  }\n"])), function (props) {
  return props.backgroundImageUrl;
}, function (props) {
  return props.heroBackgroundColor;
}, _bfBaseStyles.Breakpoints.m);
var JourneyImage = _styledComponents.default.img(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  /* width: 100%; */\n  padding-bottom: 16.5px; \n  padding-top: 16.5px;\n  max-height: 250px;\n  max-width: 45vw;\n\n  @media (min-width: ", ") {\n  }\n\n  @media (min-width: ", ") {\n    width: auto;\n    padding-bottom: 32.5px; \n    padding-top: 32.5px;\n    max-height: 400px;\n  }\n"])), _bfBaseStyles.Breakpoints.m, _bfBaseStyles.Breakpoints.l);
var JourneyTop = (0, _styledComponents.default)(function (_ref) {
  var content = _ref.content,
    children = _ref.children,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(_material.Box, {
    textAlign: "center"
  }, _react.default.createElement(_Heading.default, {
    gray: true,
    h1: true
  }, " ", content.header, " "), _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    alignItems: "center",
    textAlign: "center",
    justifyContent: 'space-between'
  }, props), _react.default.createElement(_Grid.default, Object.assign({
    display: "flex",
    justifyContent: "center",
    xs: 2,
    sm: 4,
    md: 4,
    lg: 4
  }, props), _react.default.createElement(JourneyImage, {
    src: content.aws_url__from_section_images_[0],
    alt: content.alt_image_text[0]
  })), _react.default.createElement(_Grid.default, Object.assign({
    display: "flex",
    justifyContent: "center",
    xs: 4,
    sm: 4,
    md: 4,
    lg: 4
  }, props), _react.default.createElement(JourneyImage, {
    src: content.aws_url__from_section_images_[1],
    alt: content.alt_image_text[1]
  })), _react.default.createElement(_Grid.default, Object.assign({
    display: "flex",
    justifyContent: "center",
    xs: 2,
    sm: 4,
    md: 4,
    lg: 4
  }, props), _react.default.createElement(JourneyImage, {
    src: content.aws_url__from_section_images_[2],
    alt: content.alt_image_text[2]
  }))));
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n"])));
function JourneyStack(_ref2) {
  var stackHeader = _ref2.stackHeader,
    stackImage = _ref2.stackImage,
    stackAlt = _ref2.stackAlt,
    children = _ref2.children,
    props = (0, _objectWithoutProperties2.default)(_ref2, _excluded2);
  return _react.default.createElement(_material.Box, {
    sx: {}
  }, _react.default.createElement(_system.Stack, {
    alignItems: "center"
  }, _react.default.createElement(JourneyImage, {
    src: stackImage,
    alt: stackAlt
  }), _react.default.createElement(_Heading.default, {
    h3: true,
    darkGrey: true
  }, stackHeader)));
}
;
var JourneyBottom = (0, _styledComponents.default)(function (_ref3) {
  var content = _ref3.content,
    children = _ref3.children,
    props = (0, _objectWithoutProperties2.default)(_ref3, _excluded3);
  return _react.default.createElement(_material.Box, {
    textAlign: "center",
    style: {
      marginTop: '42px'
    }
  }, _react.default.createElement(_Heading.default, {
    pink: true,
    h1: true
  }, " ", content[0].data.header, " "), _react.default.createElement(_Grid.default, Object.assign({
    container: true,
    alignItems: "center",
    textAlign: "center",
    justifyContent: 'space-around'
  }, props), _react.default.createElement(_Grid.default, Object.assign({
    display: "flex",
    xs: 10,
    sm: 4,
    md: 3,
    lg: 3
  }, props), _react.default.createElement(JourneyStack, {
    stackImage: content[1].data.aws_url__from_section_images_[0],
    stackAlt: content[1].data.alt_image_text[0],
    stackHeader: content[1].data.subheader
  })), _react.default.createElement(_Grid.default, Object.assign({
    display: "flex",
    xs: 10,
    sm: 4,
    md: 3,
    lg: 3
  }, props), _react.default.createElement(JourneyStack, {
    stackImage: content[2].data.aws_url__from_section_images_[0],
    stackAlt: content[2].data.alt_image_text[0],
    stackHeader: content[2].data.subheader
  })), _react.default.createElement(_Grid.default, Object.assign({
    display: "flex",
    xs: 10,
    sm: 4,
    md: 3,
    lg: 3
  }, props), _react.default.createElement(JourneyStack, {
    stackImage: content[3].data.aws_url__from_section_images_[0],
    stackAlt: content[3].data.alt_image_text[0],
    stackHeader: content[3].data.subheader
  }))));
})(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["\n"])));
var Journey = function Journey(_ref4) {
  var userExamples = _ref4.userExamples,
    userStats = _ref4.userStats,
    props = (0, _objectWithoutProperties2.default)(_ref4, _excluded4);
  return _react.default.createElement(JourneyBoxStyles, props, _react.default.createElement(_material.Box, null, _react.default.createElement(JourneyTop, {
    content: userExamples
  })), _react.default.createElement(_material.Box, null, _react.default.createElement(JourneyBottom, {
    content: userStats
  })));
};
var _default = Journey;
exports.default = _default;